export { default } from "./PlaceholdImage.js";
